module.exports = __webpack_public_path__ + "media/trucks/large_truck-03ea03da.svg";